// this class is the parent class that contains the methods that will be inherited. This is done so because this way we can create different views without having to duplicate functions
import icons from "url:../../img/icons.svg";

export default class View {
  _data; //public class field with underscore indicating "protected".

  render(data, render = true) {
    // data === model.state.search.results
    if (!data || (Array.isArray(data) && data.length === 0))
      return this.renderError();
    //receives data from controller.js
    this._data = data;
    const markup = this._generateMarkup(this._data);
    if (!render) return markup;

    this.#clear();
    this._parentElement.insertAdjacentHTML("beforeend", markup);
  }

  update(data) {
    //receives data from controller.js
    this._data = data; // makes data in View vecome the passed in data

    const newMarkup = this._generateMarkup(); // this markup us used to compare and check for changes

    // creating new DOM. This unrendered DOM will live in the memory and will be used to compare the HTML structure
    const newDOM = document.createRange().createContextualFragment(newMarkup); // creating a virtual DOM

    const newElements = Array.from(newDOM.querySelectorAll("*"));
    const currentElements = Array.from(
      this._parentElement.querySelectorAll("*")
    );

    newElements.forEach((newElement, i) => {
      const currentElement = currentElements[i];

      //updates changed text
      if (
        !newElement.isEqualNode(currentElement) &&
        // typeof newElement.firstChild?.nodeValue !== "string"
        newElement.firstChild?.nodeValue.trim() !== ""
      )
        //gets the first child node of each element, if there is one then the nodeValue is returned, else nodeValue returns null.
        currentElement.textContent = newElement.textContent; //The DOM gets updated because any changes to currentElement.textContent will be automatically rendered in the DOM

      //update changed HTML attributes

      if (!newElement.isEqualNode(currentElement))
        Array.from(newElement.attributes).forEach((attribute) =>
          currentElement.setAttribute(attribute.name, attribute.value)
        );
    });

    //array.from will convert the nodelist returned from querySelectorAll to an array
  }

  renderSpinner() {
    const markup = `
      <div class="spinner">
                <svg>
                  <use href="${icons}#icon-loader"></use>
                </svg>
              </div>
      `;
    this.#clear();
    this._parentElement.insertAdjacentHTML("afterbegin", markup);
    return this;
  }

  renderError(message = this._errorMessage) {
    const markup = `
      <div class="message">
              <div>
                <svg>
                  <use href="${icons}#icon-alert-triangle"></use>
                </svg>
              </div>
              <p>${message}</p>
            </div>`;
    this.#clear();
    this._parentElement.insertAdjacentHTML("beforeend", markup);
  }

  renderMessage(message = this._message) {
    const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
    this.#clear();
    this._parentElement.insertAdjacentHTML("afterbegin", markup);
  }

  #clear() {
    this._parentElement.innerHTML = "";
  }
}
